{
  "fileToImport": "File To Import",
  "importData": "Import Data",
  "overwrite": "Overwrite",
  "invalidFileTypeError1": "Invalid file type",
  "invalidFileTypeError2": "Invalid file type: Only .atb files are allowed",
  "verifyingImportFile": "Verifying import file..",
  "fileVerificationMessage": "Please be patient while your import file is being verified",
  "importingData": "Importing Data..",
  "dataImportMessage": "Please be patient while your data is being imported",
  "importWarningMessageTitle": "Warning",
  "importWarningMessage": "Warning, the import files contains the following datasources that are not selected for this client: ",
  "importSuccessTitle": "Import Success",
  "importFailureTitle": "Import Failure",
  "importSuccessText": "File {value} has been successfully imported",
  "importFailureText": "File {value} could not be imported"
}
